import Constants from 'expo-constants';

const i18n = Constants?.expoConfig?.extra?.i18n;

export const getConfigOptionLabel = (config, type, id) =>
	i18n[config.locale][id] || id || '';